import { render } from "./liqudityWarning.vue?vue&type=template&id=5270e2aa&scoped=true&lang=pug"
import script from "./liqudityWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./liqudityWarning.vue?vue&type=script&setup=true&lang=js"

import "./liqudityWarning.vue?vue&type=style&index=0&id=5270e2aa&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5270e2aa"]])

export default __exports__